export const sgcData = [
  "2022/2023 - 10.50",
  "2023/2024 - 11.00",
  "2024/2025 - 11.50",
  "2025/2026 and beyond - 12.00",
];
export const EntityTypes = {
  client: 1,
  partner: 2,
  both: 6,
  Super: 4,
  company: 3,
};
export const SuperFundType = {
  Pension: 2,
  Accumulation: 1,
  Income: 4,
  AgePension: 5,
};
export const AdvanceFilter = {
  Interest_Rate: 1,
  Repayment: 2,
  DrawDown: 3,
  LoanTerm: 4,
};

export const AdvanceInvestmentFilter = {
  Return: 1,
  Contribution: 2,
  Withdrawal: 3,
  Maturity: 4,
  MarketCrash: 5,
  MonthPickerTest: 6,
};
export const superExtraSection = { id: 0, name: "What If" };
export const AdvanceSuperFilter = {
  Accumulation: 1,
  Pension: 2,
  Contribution: 3,
  WithdrawalAccumulation: 4,
  WithdrawalPension: 5,
  MarketCrash: 6,
  PensionPayment: 7,
  FeeAccumulation: 8,
  FeePension: 9,
};
export const FooterClass = "cf-footerWrap";
export const DefaultToolTipBoxWidth = "200";
export const LargeToolTipBox = "280";
export const superClientsMenu = [
  {
    id: 1,
    name: "Return",
    isClientWise: true,
    subMenu: [
      { id: 1, name: "Accumulation" },
      { id: 2, name: "Pension" },
    ],
  },
  { id: 3, name: "Contribution", isClientWise: true, subMenu: [] },
  {
    id: 4,
    name: "Withdrawals",
    isClientWise: true,
    subMenu: [
      { id: 4, name: "Accumulation" },
      { id: 5, name: "Pension" },
    ],
  },
  { id: 6, name: "Market Crash", isClientWise: false, subMenu: [] },
  { id: 7, name: "Pension Payment", isClientWise: true, subMenu: [] },
  // {
  //   id: 8,
  //   name: "Fee",
  //   isClientWise: true,
  //   subMenu: [
  //     { id: 8, name: "Accumulation" },
  //     { id: 9, name: "Pension" },
  //   ],
  // },
];
export const tableBalanceAreaSuper = [
  {
    name: "Opening Balance",
    key: "openingBalance",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isBold: true,
  },
  {
    name: "Recontribution Strategy (Amount Applied)",
    key: "recontributionStrategy",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isBold: true,
    rightAlign: true,
  },
  {
    name: "Income Return",
    key: "incomeReturn",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    rightAlign: true,
  },
  {
    name: "Growth Return",
    key: "growthReturn",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    rightAlign: true,
  },
  {
    name: "Franking Credit",
    key: "frankingCredit",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    rightAlign: true,
  },
  {
    name: "Dividend Reinvested",
    key: "dividendReinvested",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    rightAlign: true,
  },
  {
    name: "Total Net Contributions",
    key: "contsTotalNetEOM",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isBold: true,
    rightAlign: true,
  },
  {
    name: "Total Concessional Contributions EOM",
    key: "contsConcessionalEOM",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Contributions Employer EOM",
    key: "contsEmployerEOM",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isSubHead: true,
  },
  {
    name: "Contributions Salary Sacrifice EOM",
    key: "contsSalarySacrificeEOM",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isSubHead: true,
  },
  {
    name: "Contributions Concessional EOM",
    key: "contsConcessionalEOM1",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isSubHead: true,
  },
  {
    name: "Tax on Concessional Contributions",
    key: "contsTaxOnCCEOM",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Total Non Concessional Contributions EOM",
    key: "contsTotalNonConcessionalEOM",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Contributions Non Concessional EOM",
    key: "contsNonConcessionalEOM",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isSubHead: true,
  },
  {
    name: "Contributions Spouse SOM",
    key: "contsSpouseEOM",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isSubHead: true,
  },
  {
    name: "Pension Payments",
    key: "pensionPayments",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isBold: true,
    rightAlign: true,
  },
  {
    name: "Withdrawals All",
    key: "withdrawalsAll",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isBold: true,
    rightAlign: true,
  },
  {
    name: "Expenses EOM",
    key: "expenses",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isBold: true,
    rightAlign: true,
  },
  {
    name: "Platform Fees",
    key: "platformFees",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Advice Fees",
    key: "adviceFees",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Insurance Premiums",
    key: "insurancePremium",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Other Fees",
    key: "otherFees",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Taxation",
    key: "taxation",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isBold: true,
    rightAlign: true,
  },
  {
    name: "Total Assessable Income",
    key: "taxationTotalAssessableIncome",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Total Concessional Contributions",
    key: "taxationTotalConcessionalConts",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isSubHead: true,
  },
  {
    name: "Income",
    key: "taxationIncome",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isSubHead: true,
  },
  {
    name: "Franking Credits",
    key: "taxationFrankingCredits",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isSubHead: true,
  },
  {
    name: "Expenses",
    key: "taxationExpenses",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isSubHead: true,
  },

  {
    name: "Total Tax Payable",
    key: "taxationTotalTaxPayable",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Tax Payable on Assessable Income",
    key: "taxationPayableOnAssessableIncome",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isSubHead: true,
  },
  {
    name: "Contribution Tax Paid",
    key: "taxationContributionsTaxPayable",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isSubHead: true,
  },
  {
    name: "Franking Credits",
    key: "taxationFrankingCreditsAsCredit",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isSubHead: true,
  },
  {
    name: "Contributions NCC EOM (Auto)",
    key: "contributionsEOMAuto",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isBold: true,
    rightAlign: true,
  },

  {
    name: "Withdrawals EOM (Auto)",
    key: "withdrawalsEOMAuto",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isBold: true,
    rightAlign: true,
  },
  {
    name: "Closing Balance",
    key: "closingBalance",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isBold: true,
  },
];
export const AdvanceSuperFilterComponents = {
  Accumulation: "advance-accumulation",
  Pension: "advance-pension",
  Contribution: "advance-contribution",
  MarketCrash: "super-marketcrash-filter",
  WithdrawalAccumulation: "advance-withdrawal-accumulation",
  WithdrawalPension: "advance-withdrawal-pension",
  PensionPayment: "advance-pension-payment",
  FeeAccumulation: "advance-fee-accumulation",
  FeePension: "advance-fee-pension",
};

export const AdvanceFilterInvestmentComponetName = {
  Return: "investment-return-filter",
  Contribution: "investment-contribution-filter",
  Withdrawal: "investment-withdrawal-filter",
  Maturity: "investment-maturity-filter",
  MarketCrash: "investment-marketcrash-filter",
  MonthPickerTest: "month-picker-test",
};

export const InvestmentClass = {
  AUS: "Australian Shares",
  BNK: "Bank Deposit",
  CAS: "Cash",
  DPT: "Investment Property",
  FHM: "Family Home",
  FIT: "Fixed Interest",
  INDS: "Industry Super",
  ITS: "International Shares",
  MFD: "Managed Fund",
  OTH: "Others",
  PRD: "Custom Product",
  PTT: "Property Trust",
  TXI: "Tax Effective Investment",
  ITP: "Investment Platform",
  TDP: "Term Deposit",
};

export const AdvanceSubtype = {
  Interest_Rate: {
    InterestRate: 1,
  },
  Repayment: {
    RegularType: {
      Minimum_Repayment: 1,
      InterestOnly: 2,
      PauseRepayment: 3,
      Principal_And_Interest: 4,
    },
    Regular: 1,
    LumpSum: 2,
  },
  DrawDown: {
    LumpSum: 1,
    Reguar: 2,
  },
  LoanTerm: {
    LoanTerm: 1,
  },
};

export const InvestmentAdvanceSubtype = {
  Contribution: {
    Regular: 1,
    LumpSum: 2,
  },
  Withdrawal: {
    Regular: 1,
    LumpSum: 2,
  },
};
export const SuperannuationNonSuperSubtype = {
  NonSuper: {
    Investment: 1,
    Property: 2,
  },
};
export const AdvanceFilterComponetName = {
  Interest_Rate: "loan-interest-rate-filter",
  Repayment: "loan-repayment-filter",
  DrawDown: "loan-drawdown-filter",
  LoanTerm: "loan-term-filter",
};

export const CompareOption = {
  Interest_Rate: 1,
  Repayment: 2,
  DrawDown: 3,
};
export const DefaultProjectionYear = 30;
export const MaxProjectionYear = 50;
export const StartingYearWeek = 2022;

export const LoanType = {
  Home: 9,
  Personal: 5,
  Other: 12,
};
export const InvestmentType = {
  Investment_Platform: "ITP",
  Direct_Shares: "AUS",
  Direct_Managed_Funds: "MFD",
  BANK_Account: "BNK",
  Term_Deposit: "TDP",
  Property: "DPT",
  Others: "OTH",
};
export const InvestmentCompareType = {};
export const InvestmentTypeMapping = {
  ITP: { key: "ITP", value: "1" },
  AUS: { key: "AUS", value: "2" },
  MFD: { key: "MFD", value: "3" },
  BNK: { key: "BNK", value: "4" },
  DPT: { key: "DPT", value: "5" },
  OTH: { key: "OTH", value: "6" },
  TDP: { key: "TDP", value: "7" },
};

export const IceRowType = {
  OpeningBalance: "1",
  InterestRate: "2",
  LoanRepayment: "3",
  LoanStructure: "4",
  TaxDeductibilityPercent: "5",
  LoanTerm: "6",
  LoanRepayment_LumpSum: "7",
  LoanRepayment_Pause: "8",
  LoanRepayment_Auto: "9",
  DrawDown_Reg: "10",
  DrawDown_LumpSum: "11",
  LoanRepayment_Principal_Interest: "12",
  Investment_Balance: "13",
  Investment_Income_Rate: "14",
  Investment_Growth_Rate: "15",
  Investment_Franking_Rate: "16",
  Investment_DRP: "17",
  Investment_In_Reg: "18",
  Investment_In_LS: "19",
  Investment_Out_Reg: "20",
  Investment_Out_LS: "21",
  Investment_MarketDrop: "22",
  Investment_MarketDropRecoveryPercent: "23",
  Investment_Maturity_Date: "24",

  Income_Employment_Reg: "25",
  Age_Pension: "26",
  Home_Owner: "27",
  Retire_Expense: "28",
  SuperAccumulation_Interest_Rate: "29",
  SuperAccumulation_Growth_Rate: "30",
  SuperAccumulation_Franking_Rate: "31",
  Pension_Interest_Rate: "32",
  Pension_Growth_Rate: "33",
  Pension_Franking_Rate: "34",
  Pension_Option_Min: "35",
  Pension_Option_Other: "36",
  Pension_Option_Optimise: "37",
  Use_SGC: "38",
  Employer_Amount: "39",
  Salary_Sacrifice: "40",
  Non_Concessional: "41",
  superBalance: "42",
  superPension: "43",
  rollout: "44",
  Super_Out_Reg: "45",
  Super_Out_LS: "46",
  Super_Pension_Reg: "47",
  Super_Pension_LS: "48",
  Super_MarketDrop: "49",
  Super_MarketDropRecoveryPercent: "50",
  Employer_LS_Amount: "51",
  Salary_LS_Sacrifice: "52",
  Non_LS_Concessional: "53",
};

export const IceRepaymentType = {
  Interest_Only: 2,
  Principal_And_Interest: 1,
};
export const ChartTypeDropDownValues = [
  {
    itemText: "Balance",
    itemValue: 1,
  },
];
export const ChartViewDropDownValues = [
  {
    itemText: "Chart view ",
    itemValue: 1,
  },
  // {
  //   itemText: "Multi chart view ",
  //   itemValue: 2,
  // },
  {
    itemText: "Table view",
    itemValue: 3,
  },
];
export const LoanFormElement = {
  OpeningBalance: [{ key: "openingBalance", map: "Amount" }],
  InterestRate: [{ key: "interestRate", map: "Amount" }],
  LoanStructure: [{ key: "repaymentType", map: "Amount" }],
  LoanRepayment: [
    { key: "repaymentAmount", map: "Amount" },
    { key: "repaymentFrequency", map: "Frequency" },
  ],
  TaxDeductibilityPercent: [{ key: "taxDeductibilityPercent", map: "Amount" }],
  LoanTerm: [{ key: "loanTerm", map: "Amount" }],
};
export const incomeExpenseGraphId = "incomeexpense";
export const ChartConfig = {
  BalanceGraph: {
    text: "Balance",
    yAxisLabel: "Asset Balance",
    component: "chart-area",
    legendItems: "Balance",
  },
  IncomeExpenseGraph: {
    text: "Income & Expense",
    yAxisLabel: "Amount",
    component: "chart-bar-line",
    legendItems: [
      { text: "Inflow", legendKeyType: "bar" },
      { text: "Outflow (Inc Tax)", legendKeyType: "line-solid" },
    ],
    legendColors: ["#7a90c9", "red"],
    lineColor: ["red"],
  },
  ContributionGraph: {
    text: "Contributions and Withdrawals",
    yAxisLabel: "Contributions and Withdrawals",
    component: "chart-bar",
    legendItems: ["Contributions", "Withdrawals"],
    legendColors: ["#7999cf", "#ff6666"],
  },
  ReturnFeesGraph: {
    text: " Return & Fees",
    yAxisLabel: "Return & Fees",
    component: "chart-bar",
    legendItems: ["Income", "Growth", "Fees"],
    legendColors: ["#7999cf", "#f9dc66", "#ff6666"],
  },
  TimeSeriesFeesGraph: {
    text: "Timeline",
    yAxisLabel: "",
    component: "chart-time-series",
    legendItems: ["Base Return", "Return Adjustments"],
    legendColors: ["#e5e5e5", "#1f55af"],
  },
};

export const InvestmentFormElement = {
  Investment_Balance: [{ key: "amount", map: "Amount" }],
  Investment_Income_Rate: [{ key: "incomeRate", map: "Amount" }],
  Investment_Growth_Rate: [{ key: "growthRate", map: "Amount" }],
  Investment_Franking_Rate: [{ key: "frankingRate", map: "Amount" }],
  Investment_In_Reg: [
    { key: "contributionAmount", map: "Amount" },
    { key: "durationTypeId", map: "Frequency" },
  ],
  Investment_DRP: [{ key: "isDRP", map: "Amount" }],
  Investment_Maturity_Date: [{ key: "maturityDate", map: "Amount" }],
};

export const projectionType = {
  loan: 1,
  Investemnt: 2,
  Super: 3,
  SuperIncome: 4,
  SuperAgePension: 5,
  Accumulation: 6,
  Pension: 7,
};

export const IceDurationType = {
  Weeks: "Weekly",
  Years: "Yearly",
  Months: "Monthly",
  Fortnights: "Fortnightly",
  Half_Year: "Half-Yearly",
};

export const DurationType = {
  Weeks: 5,
  Years: 1,
  Months: 3,
  Fortnights: 4,
  Half_Year: 6,
};

export const DefaultRetirementDate = 65;
export const RepaymentOptionList = [
  {
    text: "Weekly",
    value: "5",
  },
  {
    text: "Fortnightly",
    value: "4",
  },
  {
    text: "Monthly",
    value: "3",
  },
  {
    text: "Half Yearly",
    value: "6",
  },
  {
    text: "Yearly",
    value: "1",
  },
];
export const DurationOption = [
  {
    text: "Weekly",
    value: DurationType.Weeks,
  },
  {
    text: "Fortnightly",
    value: DurationType.Fortnights,
  },
  {
    text: "Monthly",
    value: DurationType.Months,
  },
  {
    text: "Half Yearly",
    value: DurationType.Half_Year,
  },
  {
    text: "Yearly",
    value: DurationType.Years,
  },
];
export const GrowthOption = [
  {
    text: "AWOTE",
    value: 1,
  },
  {
    text: "CPI",
    value: 2,
  },
  {
    text: "NONE",
    value: 3,
  },
];
export const PensionOption = [
  {
    text: "Minimum",
    value: 1,
  },
  {
    text: "Other",
    value: 2,
  },
  {
    text: "Optimise",
    value: 3,
  },
];
export const PensionOptionType = {
  Minimum: 1,
  Other: 2,
  Optimise: 3,
};
export const DATETYPE = {
  Start: 1,
  Start_Fy: 2,
  Max: 3,
  Client_Retirement: 4,
  Partner_Retirement: 5,
  Other: 6,
  None: 7,
};
export const GrowthIndex = {
  AWOTE: 1,
  CPI: 2,
  NONE: 3,
};
export const WithdrawalIndex = {
  CONTRIBUTION: 1,
  SALARYSACRIFICE: 2,
  NONCONCESSIONAL: 3,
};
export const OptionIndex = {
  PersentOnly: 1,
  AmountOnly: 2,
  PersentWithAmountCap: 3,
};
export const FeeTypeIndex = {
  Platform: 1,
  Admin: 2,
  Insurance: 3,
  Other: 4,
};
export const SuperAdvanceType = {
  LumpSum: 3,
};
export const RepaymentOptions = {
  InterestOnly: 1,
  PrincipleandInterest: 2,
  LumpSum: 3,
  PauseRepayments: 4,
  AutoRepayments: 5,
};
export const RepaymentTypeOptionValue = {
  Minimum_Repayment: 0,
  first_Repayment_Year: 1,
  second_Repayment_Year: 2,
  third_Repayment_Year: 3,
  fourth_Repayment_Year: 4,
  fifth_Repayment_Year: 5,
  Specific_Repayment_Amount: 6,
};
export const RepaymentTypeOptions = [
  {
    text: "Minimum Amount",
    value: RepaymentTypeOptionValue.Minimum_Repayment,
  },
  {
    text: "1 Year Interest Only",
    value: RepaymentTypeOptionValue.first_Repayment_Year,
  },
  {
    text: "2 Year Interest Only",
    value: RepaymentTypeOptionValue.second_Repayment_Year,
  },
  {
    text: "3 Year Interest Only",
    value: RepaymentTypeOptionValue.third_Repayment_Year,
  },
  {
    text: "4 Year Interest Only",
    value: RepaymentTypeOptionValue.fourth_Repayment_Year,
  },
  {
    text: "5 Year Interest Only",
    value: RepaymentTypeOptionValue.fifth_Repayment_Year,
  },
  {
    text: "Other Amount",
    value: RepaymentTypeOptionValue.Specific_Repayment_Amount,
  },
];
export const DialogAction = {
  Duplicate: 1,
  Rename: 2,
  Delete: 3,
};

export const ACTION_EOM = 2;

export const currencyFormat = "$,.2f";

export const numberToDecimalFormat = ".2f";
export const ApplicationName = "cashflow30";
export const currencyNumberFormat = "$,.0f";
export const RepeymentTypeSelectOptions = [
  {
    text: "Minimum Amount",
    value: "1",
  },
  {
    text: "Interest Only",
    value: "2",
  },
  {
    text: "Pause Payments",
    value: "3",
  },
  {
    text: "Other Amount",
    value: "4",
  },
];
export const tableViewAreaLoan = [
  {
    name: "Opening Balance",
    key: "openingBalance",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isBold: true,
  },
  {
    name: "Drawdown SOM",
    key: "drawdownSOM",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Repayment SOM",
    key: "repaymentSOM",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Principal",
    key: "capitalPaid",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Interest Payable",
    key: "interestPayable",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Interest Offset",
    key: "interestOffset",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },

  {
    name: "Drawdown EOM",
    key: "drawdownEOM",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Repayment EOM",
    key: "repaymentEOM",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Drawdown EOM (Auto)",
    key: "drawdownEOMAuto",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Repayment EOM (Auto)",
    key: "repaymentEOMAuto",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Closing Balance",
    key: "closingBalance",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isBold: true,
  },

  //ok
];
export const tableBalanceAreaInvestment = [
  {
    name: "Opening Balance",
    key: "openingBalance",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isBold: true,
  },
  {
    name: "Withdrawals SOM",
    key: "withdrawalsSOM",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Contributions SOM",
    key: "contributionsSOM",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Income Return",
    key: "incomeReturn",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Growth Return",
    key: "growthReturn",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Franking Credit",
    key: "frankingCredit",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Dividend Reinvested",
    key: "dividendReinvested",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Contributions EOM",
    key: "contributionsEOM",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Withdrawals EOM",
    key: "withdrawalsEOM",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Platform Fees",
    key: "platformFees",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Advice Fees",
    key: "adviceFees",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Other Fees",
    key: "otherFees",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Contributions EOM (Auto)",
    key: "contributionsEOMAuto",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Withdrawals EOM (Auto)",
    key: "withdrawalsEOMAuto",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    subRightAlign: true,
  },
  {
    name: "Closing Balance",
    key: "closingBalance",
    mappedkey: "",
    isAmount: true,
    AllowNegative: true,
    isBold: true,
  },
];
export const DownloadOption = [
  {
    text: "Excel Download",
    value: "1",
    iconPath: require("../assets/icons/excel.svg"),
  },
  {
    text: "PDF Download",
    value: "2",
    iconPath: require("../assets/icons/pdf.svg"),
  },
  {
    text: "Word Download",
    value: "3",
    iconPath: require("../assets/icons/word.svg"),
  },
];
export const LoanExcelFileSuccessMessage = "File has downloaded.";
export const LoanExcelFileErrorMessage = "Failed to  downloaded file.";
